import { Typography } from 'antd';
import { isNil, noop } from 'lodash';
import React, { useEffect, useState } from 'react';
import AppSearchInput from './AppSearchInput';
import { useModalState } from '../hooks/useModalState';
import SupplierInvoiceSearchModal from './SupplierInvoiceSearchModal';

export type SupplierInvoiceSelectedType = {
  siid?: number;
  sireference?: string;
  suppliername?: string;
};

export type SupplierInvoiceSelectProps = {
  onChange?: any;
  value?: SupplierInvoiceSelectedType | any;
  clear?: boolean;
  onlysiid?: boolean;
  ctref?: string;
};

const SupplierInvoiceSelect = ({
  onChange = noop,
  value,
  clear,
  onlysiid,
  ctref
}: SupplierInvoiceSelectProps) => {
  const [Params, setParams] = useState<SupplierInvoiceSelectedType>({
    siid: value?.siid,
    sireference: value?.sireference,
    suppliername: value?.suppliername,
  });

  const { visible, close, open } = useModalState(false);
  // eslint-disable-next-line no-unused-vars
  const [onClear, setOnClear] = useState(false);

  const handleSelect = (item: any) => {
    onlysiid ? onChange(item.siid) : onChange(item);
    setParams({
      sireference: item?.sireference,
      suppliername: item.suppliername,
      siid: item?.siid,
    });
    setOnClear(true);
    close();
  };

  useEffect(() => {
    setParams({
      sireference: undefined,
      suppliername: undefined,
      siid: undefined,
    });
    setOnClear(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    value = undefined;
  }, [clear]);

  return (
    <>
      <AppSearchInput
        onSearch={() => {
          open();
          localStorage.removeItem('searchParams');
          localStorage.removeItem('searchParams_components');
        }}
        value={
          <Typography.Link>
            {!value?.siid
              ? Params?.siid && value !== 0 && value !== '' && !isNil(value)
                ? `${Params.sireference ?? ''}  -  ${Params.suppliername ?? ''}`
                : 'Select an Invoice'
              : value?.siid && value !== 0 && value !== '' && !isNil(value)
              ? `${value.sireference ?? ''}  -  ${value.suppliername ?? ''}`
              : 'Select an invoice'}
          </Typography.Link>
        }
      />
      <SupplierInvoiceSearchModal
        visible={visible}
        onCancel={close}
        setSupplierInvoice={handleSelect}
        ctref={ctref}
      />
    </>
  );
};

export default SupplierInvoiceSelect;
